import { ExtendedPaymentFormField } from 'src/types';

export function generateSelectOptionsForFormGenerator(
  field: ExtendedPaymentFormField
): [string, string][] {
  if (field.options) {
    return Object.entries(field.options);
  }
  return Object.entries(field.value);
}
